import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRouting } from './home.routes';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { HomeComponent } from './home.component';
import { GlobalNetworkDropdownModule } from '../global-header/network/global-network-dropdown.module';
import { GlobalHeaderAutosuggestModule } from '../global-header/autosuggest/global-header-autosuggest.module';
import { GlobalLocationSelectModule } from '../global-header/location/global-location-select.module';
import { LnpModule } from '@services/lnp/lnp.module';
import { GlobalMembersDropdownModule } from '../members';
import { PromotionalBenefitsComponent } from './promotional-benefits/promotional-benefits.component';
import { PromotionalSmartshopperComponent } from './promotional-smartshopper/promotional-smartshopper.component';
import { BenefitCardComponent } from './promotional-benefits/benefit-card/benefit-card.component';
import { LoginPromptComponent } from './login-prompt/login-prompt.component';
import { ExternalLinksComponent } from './external-links/external-links.component';
import { PageContainerModule } from '@zelis/platform-ui-components';
import { PcpModule } from '../pcp/pcp.module';
import { DelightedModule } from '@directives/delighted/delighted.module';
import { ConvenientCareComponent } from './convenient-care/convenient-care.component';
import { EmailCollectionTrayModule } from '../email-collection-tray/email-collection-tray.module';
import { UserPreferencesService } from '../../services/user.preferences.service';
import { QuickLinksModule } from '../quick-links/quick-links.module';
import { GtmModule } from '@directives/gtm/gtm.module';
import { PromotionalProceduresComponent } from './promotional-procedures/promotional-procedures.component';
import { SvgModule } from '@zelis/platform-ui-components';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ProceduresAwarenessOverlay } from '@classes/procedures-awareness-overlay.class';
import { ProceduresAwarenessOverlayModule } from './procedures-awareness-overlay';
import { RtsWelcomeOverlay } from '@classes/rts-welcome-overlay.class';
import { RtsWelcomeOverlayModule } from '../right-to-shop/rts-welcome-overlay';
import { DisclaimersModule } from '../disclaimers';
import { AncillaryNetworksModule } from '../ancillary-networks/ancillary-networks.module';
import { RtsWelcomeBannerModule } from './rts-welcome-banner/rts-welcome-banner.module';
import { TelehealthModule } from '@components/telehealth/telehealth.module';
import { FixedTooltipModule } from '../fixed-tooltip/fixed-tooltip.module';
import { ContentMessagingModule } from '@components/content-messaging/content-messaging.module';
import { WelcomeBannerModule } from '../welcome-banner/welcome-banner.module';
import { GuidedSearchBrowseByModule } from '@components/guided-search/guided-search-browse-by/guided-search-browse-by.module';
import { GuidedSearchTriggerModule } from '@components/guided-search/guided-search-trigger/guided-search-trigger.module';
import { MedicationFinderSavingsModule } from './medication-finder-savings/medication-finder-savings.module';
import { NetworkLocationMembersModule } from '@components/network-location-members/network-location-members.module';
import { SearchByBillingModule } from './search-by-billing-link/search-by-billing-link-module';
import { DlsButtonModule } from '@zelis/dls/button';
import { DlsLozengeModule } from '@zelis/dls/lozenge';
import { DlsIconModule } from '@zelis/dls/icons';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HomeRouting,
    FlexLayoutModule,
    TranslateModule,
    GlobalNetworkDropdownModule,
    GlobalHeaderAutosuggestModule,
    GlobalLocationSelectModule,
    PageContainerModule,
    LnpModule,
    GlobalMembersDropdownModule,
    PcpModule,
    DelightedModule,
    EmailCollectionTrayModule,
    QuickLinksModule,
    GtmModule,
    SvgModule,
    MatBottomSheetModule,
    ProceduresAwarenessOverlayModule,
    DisclaimersModule,
    AncillaryNetworksModule,
    RtsWelcomeOverlayModule,
    RtsWelcomeBannerModule,
    TelehealthModule,
    FixedTooltipModule,
    ContentMessagingModule,
    WelcomeBannerModule,
    GuidedSearchBrowseByModule,
    GuidedSearchTriggerModule,
    MedicationFinderSavingsModule,
    NetworkLocationMembersModule,
    SearchByBillingModule,
    DlsButtonModule,
    DlsLozengeModule,
    DlsIconModule,
  ],
  declarations: [
    HomeComponent,
    PromotionalSmartshopperComponent,
    PromotionalBenefitsComponent,
    BenefitCardComponent,
    LoginPromptComponent,
    ExternalLinksComponent,
    ConvenientCareComponent,
    PromotionalProceduresComponent,
    ContactUsComponent,
  ],
  providers: [
    UserPreferencesService,
    ProceduresAwarenessOverlay,
    RtsWelcomeOverlay,
  ],
})
export class HomeModule {}
